export const fetchAssets = (roleId, search, location) =>
    fetch(`${process.env.REACT_APP_API_URL}/api/app/search/assets`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            roleId,
            search,
            objectLocation: location
                ? location.id : undefined,
            limit: 1000
        })
    })
        .then(resp => resp.json())
        .then(resp => resp.results)
        .catch(console.error);
